__turbopack_context__.v({
  "className": "roboto_dc42ee18-module__Yt-3JW__className",
});
